export const propertyCarTitle = (
	carBrand: string | null | undefined,
	carModel: string | null | undefined,
	carLicensePlate: string | null | undefined,
) => {
	const brandModel = [carBrand, carModel].filter(Boolean).join(" ");
	const licensePlate = carLicensePlate ? `(${carLicensePlate})` : "";

	if (brandModel && licensePlate) {
		return `${brandModel} ${licensePlate}`;
	}

	if (brandModel) {
		return brandModel;
	}

	if (carLicensePlate) {
		return carLicensePlate;
	}

	return "";
};
